export const getBourboulencFranceData = () => ({
  name: "Bourboulenc",
  country: "France",
  description: "Bourboulenc est un cépage blanc rare originaire du Languedoc, principalement cultivé dans le sud de la France où il produit des vins blancs fins et élégants.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "0.2%", description: "Cépage blanc rare, apportant finesse et notes d'amande" },
    { name: "Languedoc-Roussillon", area: "200 ha", percentage: "1%", description: "Cultivé dans quelques appellations traditionnelles" },
    { name: "Côtes du Rhône", area: "50 ha", percentage: "0.5%", description: "Utilisé dans quelques assemblages" },
    { name: "Provence", area: "25 ha", percentage: "0.2%", description: "Utilisé dans quelques vins blancs" },
    { name: "Autres", area: "25 ha", percentage: "0.1%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Languedoc", x: 48, y: 62, color: "#6d2c7a", size: 2 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#8a4a8a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage rare et difficile à cultiver, sensible aux maladies",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    white: "Vins blancs fins avec des notes d'amande, minérales et élégantes"
  },
  foodPairing: "Poissons, fruits de mer, volailles, fromages frais, cuisine provençale",
  history: "Bourboulenc est un cépage blanc très ancien et rare du Languedoc, mentionné dans les textes historiques. Son nom pourrait être lié à une caractéristique particulière du cépage ou à son origine géographique. Il est aujourd'hui principalement cultivé dans quelques appellations traditionnelles du sud de la France où il apporte finesse et élégance aux assemblages."
}); 